import { AccountsAccessRights } from "components/UserAccessRights.ts";

export const BILL_MODE = {
  Post: "post",
  CreateRequest: "createRequest",
  UpdateRequest: "updateRequest",
  ReadOnly: "readOnly",
};

export const BILL_MODE_CONFIG = {
  [BILL_MODE.Post]: {
    label: "Post",
    right: AccountsAccessRights.AddBills,
  },
  [BILL_MODE.CreateRequest]: {
    label: "Submit Request",
    right: null,
  },
  [BILL_MODE.UpdateRequest]: {
    label: "Update Request",
    right: null,
  },
  [BILL_MODE.ReadOnly]: {
    label: null,
    right: null,
  },
};

export function resolveBillMode({
  isBillRequest,
  isBillingRequest,
  isRejected,
  isPendingPosting,
}) {
  if (isBillRequest) {
    if (isRejected) return BILL_MODE.UpdateRequest;
    if (isPendingPosting) return BILL_MODE.Post;
    return BILL_MODE.ReadOnly;
  }
  return isBillingRequest ? BILL_MODE.CreateRequest : BILL_MODE.Post;
}

export function getBillModeConfig(mode) {
  return BILL_MODE_CONFIG[mode] ?? BILL_MODE_CONFIG[BILL_MODE.ReadOnly];
}
